import React, { useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';

// The Hold / Approved serial list moved to Axillon App in Oct 2026, where Smart
// Shipper reads it. This route stays so the tile and bookmarks still land
// somewhere useful: it says where the list went and forwards after a moment.
const NEW_SERIAL_LIST_URL = 'https://axillon-app.axillonaerospace.com/shipper/serial-list/';
const REDIRECT_DELAY_MS = 3000;

const SmartShipperBlacklist = () => {
  useEffect(() => {
    const timer = setTimeout(() => window.location.replace(NEW_SERIAL_LIST_URL), REDIRECT_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Box component="main" sx={{ mt: 4 }}>
      <Box
        sx={{
          backgroundColor: '#f9f9f9',
          padding: 4,
          borderRadius: 2,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          marginTop: '50px',
          marginBottom: 4,
          textAlign: 'center',
          maxWidth: 640,
          mx: 'auto',
        }}
      >
        <Typography variant="h5" sx={{ mb: 2 }}>
          The Hold / Approved serial list has moved
        </Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
          The SmartShipper serial list is now managed in Axillon App, where Smart Shipper checks it.
          Changes made here no longer apply.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Taking you there now. Axillon App is on the company network, so connect to the VPN if you are off site.
        </Typography>
        <Button variant="contained" href={NEW_SERIAL_LIST_URL}>
          Open the Serial List in Axillon App
        </Button>
      </Box>
    </Box>
  );
};

export default SmartShipperBlacklist;
